import { h, Component } from 'preact'

let watching = false
let hoverDisable = false
let listeners = []

function watchForHover() {
  if (watching) return
  watching = true
  let lastTouchTime = 0

  function enableHover() {
    // filter emulated events coming from touch events
    if (new Date() - lastTouchTime < 500) return

    if (hoverDisable) {
      hoverDisable = false
      listeners.forEach(l => l(false))
    }
  }

  function disableHover() {
    if (!hoverDisable) {
      hoverDisable = true
      listeners.forEach(l => l(true))
    }
  }

  function updateLastTouchTime() {
    lastTouchTime = new Date()
  }
  if (typeof document !== 'undefined') {
    document.addEventListener('touchstart', updateLastTouchTime, true)
    document.addEventListener('touchstart', disableHover, true)
    document.addEventListener('mousemove', enableHover, true)
  }

  enableHover()
}

watchForHover()

class HoverDisablerComp extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.onHoverDisable !== nextProps.onHoverDisable) {
      const last = this.props.onHoverDisable
      const cur = nextProps.onHoverDisable
      if (last) {
        listeners = listeners.filter(l => l !== last)
      }
      if (cur) {
        listeners.push(cur)
      }
    }
    return true
  }

  lastDisableListener = null
  render() {
    return <span>{this.props.children}</span>
  }
}

export default C =>
  class HoverDisabler extends Component {
    state = { hoverDisable }
    render() {
      return (
        <HoverDisablerComp
          onHoverDisable={() => this.setState({ hoverDisable })}
        >
          <C {...this.props} hoverDisable={this.state.hoverDisable} />
        </HoverDisablerComp>
      )
    }
  }



// WEBPACK FOOTER //
// ./components/hoverDisabler.js